import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import confirmDialog from '@/components/dialog/confirm'

function renderDialog(h) {
  return h(
    confirmDialog,
    {
      props: {
        value: this.showDialog,
        title: this.getTranslate(`${this.serviceNameViaPoint}.titles.cancel`),
        content: this.getTranslate(`${this.serviceNameViaPoint}.contents.cancel`, { name: this.value?.name ?? '' }),
        color: Colors.warning,
        callback: this.cancel,
        loading: this.loading,
        disabled: this.disabled,
        maxWidth: 450
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    }
  )
}

export default function(h) {
  if (this.isFinalStatus) {
    return null
  }

  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate('misc.buttons.cancel'),
        icon: icons.do_not_disturb,
        iconColor: Colors.warning,
        dense: true,
        loading: this.loading,
        disabled: this.disabled
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
